export const Balloon = require('../assets/Balloon.png')
export const BarcodeHorizontal = require('../assets/BarcodeHorizontal.png')
export const BarcodeVertical = require('../assets/BarcodeVertical.png')
export const CanEatLogo = require('../assets/LogoQlFullPrimary.png')
export const Cookie = require('../assets/Cookie.png')
export const LogoWithBarcode = require('../assets/Logo.png')
export const PremiumCodeLogo = require('../assets/PremiumCodeLogo.png')
export const Onion = require('../assets/Onion.gif')
export const Owl = require('../assets/Owl.gif')
export const Hill = require('../assets/Hill.png')
export const Hill2x = require('../assets/Hill2x.png')
export const Hill3x = require('../assets/Hill3x.png')
export const English = require('../assets/English.png')
export const Norway = require('../assets/Norway.png')
export const Ukraine = require('../assets/Ukraine.png')
export const UserIcon = require('../assets/UserIcon.png')

const ASSETS = {
  Balloon,
  BarcodeHorizontal,
  English,
  Ukraine,
  CanEatLogo,
  LogoWithBarcode,
  PremiumCodeLogo,
  Owl,
  Cookie,
  BarcodeVertical,
  Norway,
  Onion,
  Hill,
  Hill2x,
  Hill3x,
  UserIcon
}

export default ASSETS
